var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0CBA9D",
    d: "M10.177.979c.096.032.187.078.27.137.082.055.163.126.246.208l5.241 5.241c.296.294.464.691.468 1.107.001.208-.04.413-.122.603a1.969 1.969 0 0 1-.346.53 1.572 1.572 0 0 1-1.12.442 1.571 1.571 0 0 1-1.119-.443l-2.56-2.584v9.868a1.534 1.534 0 0 1-.454 1.107 1.502 1.502 0 0 1-1.12.468 1.512 1.512 0 0 1-1.107-.468 1.511 1.511 0 0 1-.468-1.107V6.22l-2.56 2.584a1.503 1.503 0 0 1-1.106.443 1.503 1.503 0 0 1-1.107-.443 1.528 1.528 0 0 1-.468-1.12c0-.435.157-.807.468-1.119l5.241-5.24a.95.95 0 0 1 .234-.21A1.28 1.28 0 0 1 8.971.98h.025a.767.767 0 0 1 .27-.097 1.792 1.792 0 0 1 .603 0c.098.019.193.051.282.097h.026Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export default ForwardRef;